import { APIClass } from 'aws-amplify';
import { apiClient } from './api-client';

export const documentsClient = (API: APIClass) => {
  return {
    getOrgDocuments: async (orgId: string, setIsLoading: (isLoading: boolean) => void) => {
      return await apiClient(API).get(`/documents/${orgId}`, setIsLoading);
    },

    getUserDocuments: async (userId: string, setIsLoading: (isLoading: boolean) => void) => {
      return await apiClient(API).get(`/documents/user/${userId}`, setIsLoading);
    },

    getOrgDocumentById: async (orgId: string, documentId: string, setIsLoading: (isLoading: boolean) => void) => {
      return await apiClient(API).get(`/documents/${orgId}/${documentId}`, setIsLoading);
    },

    getUserDocumentById: async (userId: string, documentId: string, setIsLoading: (isLoading: boolean) => void) => {
      return await apiClient(API).get(`/documents/user/${userId}/${documentId}`, setIsLoading);
    },

    createDocument: async (body: Record<string, any>, setIsLoading: (isLoading: boolean) => void) => {
      return await apiClient(API).post(`/documents`, body, setIsLoading);
    },

    createUserDocument: async (
      body: { userId: string; s3Key: string; fileName: string },
      setIsLoading: (isLoading: boolean) => void
    ) => {
      return await apiClient(API).post(`/documents/user`, body, setIsLoading);
    },

    deleteOrgDocument: async (orgId: string, documentId: string, setIsLoading: (isLoading: boolean) => void) => {
      return await apiClient(API).delete(`/documents/${orgId}/${documentId}`, setIsLoading);
    },
  };
};
